







import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@root/common/const/e-chart-options';

@Component({})
export default class EchartPie extends Vue {
  @Prop()
  title: string;
  @Prop()
  seriesData: any[];
  @Prop()
  total: number;
  options: EchartOption = new EchartOption();
  isData = false;

  get selected() {
    let selected = {};
    this.seriesData.forEach(item => {
      selected[item.name] = true;
    });
    return selected;
  }

  @Watch('seriesData', { deep: true })
  seriesDataChange() {
    this.initChart();
  }

  created() {
    this.initChart();
  }

  initChart() {
    const options = new EchartOption();
    if (this.seriesData.length > 0) {
      options.setTitle({
        text: this.total,
        top: 'center',
        left: 'center',
        textStyle: {
          color: '#333',
          fontSize: 20
        }
      });
    } else {
      options.setTitle({
        text: '暂无数据',
        top: 'center',
        left: 'center',
        textStyle: {
          color: '#333',
          fontSize: 18
        }
      });
    }
    options.setTooltip({
      show: true,
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c} ({d}%)'
    });
    options.setLegend({
      type: 'scroll',
      orient: 'horizontal',
      left: 0,
      bottom: -6,
      data: this.seriesData.map(item => item.name),
      selected: this.selected
    });
    options.setSeries([
      {
        name: this.title,
        type: 'pie',
        radius: ['50%', '70%'],
        startAngle: 135, //起始角度
        data: this.seriesData,
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          position: 'outer',
          alignTo: 'labelLine',
          formatter: `{c}`,
          color: '#748194',
          fontSize: 12
        },
        labelLine: {
          length: 0,
          length2: 10
        }
      }
    ]);
    this.options = options;
    this.isData = true;
  }
}
